import Core from "./Core";
import Compile from "./Compile";
export default {
  name: "About",
  components: {
    Core: Core,
    Compile: Compile
  }
};